import { render, staticRenderFns } from "./ImagesTrain.vue?vue&type=template&id=70e0ba78&scoped=true"
import script from "./ImagesTrain.vue?vue&type=script&lang=js"
export * from "./ImagesTrain.vue?vue&type=script&lang=js"
import style0 from "./ImagesTrain.vue?vue&type=style&index=0&id=70e0ba78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0ba78",
  null
  
)

export default component.exports